import React, { Component } from 'react';

class TrackToggleButton extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    isToggled() {
        return this.props.track.isEnabled;
    }

    onToggleClicked() {
        this.props.track.toggleEnabled();
        this.setState(this.state);
    }

    render() {
        return (
            <div
              onClick={() => this.onToggleClicked()}
              className={this.isToggled() ? 'toggled track-toggle-button' : 'track-toggle-button'}>
            </div>
        );
    }
}

export default TrackToggleButton;
